import React from "react";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import ShippingCostSettingAdminRow from "./ShippingCostSettingAdminRow";
import ShippingModalAdmin from "./ShippingModalAdmin";
import ConfirmationModal from "../../../sub/modals/ConfirmationModal";

class ShippingCostSettingAdmin extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modal: null,
    };
  }

  openShippingModal(index, successCallback) {
    this.setState({
      modal: (
        <ShippingModalAdmin
          index={index}
          shippingCosts={this.props.ordersSettingsAdmin.shipping_costs}
          successCallback={successCallback}
          closeModal={() => this.closeModal()}
        />
      ),
    });
  }

  openConfModal(title, content, successCallback) {
    this.setState({
      modal: (
        <ConfirmationModal
          title={title}
          onAccept={successCallback}
          onDecline={() => this.closeModal()}
        >
          {content}
        </ConfirmationModal>
      ),
    });
  }

  closeModal() {
    this.setState({ modal: null });
  }

  render() {
    var index = -1;
    let shippingCostNode = this.props.ordersSettingsAdmin.shipping_costs.map(
      (shippingCost) => {
        return (
          <ShippingCostSettingAdminRow
            index={++index}
            key={index}
            shippingCost={shippingCost}
            shippingCosts={this.props.ordersSettingsAdmin.shipping_costs}
            openConfModal={(title, content, successCallback) =>
              this.openConfModal(title, content, successCallback)
            }
            openShippingModal={(index, successCallback) =>
              this.openShippingModal(index, successCallback)
            }
          />
        );
      },
    );

    return (
      <React.Fragment>
        {this.state.modal}
        <table className="table table-striped tablee4mad">
          <thead>
            <tr>
              <th>
                <span>
                  <FormattedMessage id="Minimum" />
                </span>
              </th>
              <th>
                <FormattedMessage id="Maximum" />
              </th>
              <th>
                <FormattedMessage id="Shipping.Cost.Excl.Tax" />
              </th>
              <th>
                <FormattedMessage id="Actions" />
              </th>
            </tr>
          </thead>
          <tbody>{shippingCostNode}</tbody>
        </table>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ShippingCostSettingAdmin);
